import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { ResponseRma } from "@/types";
import axios from "axios";
import AuthenticationModel from "./AuthenticationModel";
import { LanguagePackage } from "./LanguagePackage";
import Rma from "./RmaModel";
import UserModel from "./UserModel";

export default new Vuex.Store({
  state: {
    rma: new Rma(),
    authentication: new AuthenticationModel(),
    createdRmaList: Array<Rma>(),
    localLanguagePack: new LanguagePackage(),
    rmaReasons: Array<string>(), // Thats a lie
    userRmas: Array<ResponseRma>(),
    user: {} as UserModel,
    needCustomTransport: false,
    isShadow: false
  },

  getters: {
    async getRmaReasons(state): Promise<Array<string>> {
      const reasons = await axios.get("/rma/reasons");
      state.rmaReasons = reasons.data ? reasons.data : [];
      return state.rmaReasons;
    },
    getUserRmas(state): Array<ResponseRma> {
      return state.userRmas;
    },
    getIsDealer(state): boolean {
      return state.user.isDealer;
    },
    getIsEnterprise(state): boolean {
      return state.user.isEnterprise;
    },
    getCurrentRmaId(state) {
      return state.rma.rmaId;
    },
    usesDealerCustomOptions(state): boolean {
      const {
        dealerOptionsPickupDirectly,
        dealerOptionsRetourDirectly
      } = state.rma;
      return [dealerOptionsPickupDirectly, dealerOptionsRetourDirectly].some(
        value => value === true
      );
    }
  },

  mutations: {
    setToken(state, token: string) {
      state.authentication.token = token;
      localStorage.setItem("authenticationToken", token);
    },
    cleanRma(state) {
      state.rma = new Rma();
      state.needCustomTransport == false;
    },
    rmaSetDate(state, newDate: Date) {
      state.rma.upsPickupPreveredDate = newDate.toString();
    },
    setRmaId(state, id: number) {
      state.rma.rmaId = id;
    },
    setUser(state, user: UserModel) {
      state.user = user;
    }
  },
  actions: {
    setToken(context, token: string) {
      context.commit("setToken", token);
    },
    cleanRma(context) {
      context.commit("cleanRma");
    },
    async uploadRma(context) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      const lazyRma: any = Object.assign({}, context.state.rma);
      lazyRma.model = { fmId: context.state.rma.model.fmId };

      const axiosResponse = await axios.put(
        `/rma${
          context.state.rma.rmaId ? "?rmaId=" + context.state.rma.rmaId : ""
        }`,
        lazyRma
      );
      if (axiosResponse.data) {
        context.commit("setRmaId", axiosResponse.data.id);
      }
    },
    rmaSetDate(context, newDate: Date) {
      context.commit("rmaSetDate", newDate);
    },
    async downloadUserRmas(context) {
      const returnData = await axios.get("/rmas?complete=false");
      context.state.userRmas = returnData.data ? returnData.data : [];
    },
    async getUserInfo(context) {
      const returnData = await axios.get("/user/thumb");
      const user = new UserModel(returnData.data);
      if (user) context.commit("setUser", user);
    }
  }
});
